/** @fileoverview update_notification_setting の共通定数 */

/** ツール名（単一参照点） */
export const UPDATE_NOTIFICATION_SETTING_NAME =
  "update_notification_setting" as const;

/** LLM へ提示する説明文 */
export const UPDATE_NOTIFICATION_SETTING_DESC =
  `Updates workspace notification settings.

Use this when a user wants to enable or disable workspace notifications for new data.

Input:
- 'organizationId' (required): Target workspace/organization ID.
- 'notificationType' (required): 'NEW_DATA'.
- 'enabled' (required): true to enable notifications, false to disable.

Notes:
- Write operation; confirmation is required before execution.
- Returns the updated organization id and doNotNotifyTypes.` as const;
